import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Sidebar = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Sidebar' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,22 L23,22 L23,2 L1,2 L1,22 Z M16,2 L16,22 L16,2 Z' />
  </StyledIcon>
);
